<div [ngClass]="{'expandable-container': true, 'expandable-container--open': showDetail}">
  <div class="expandable-item" (click)="toggleDetails()">
    <ng-content select="[expandable-item]"></ng-content>
    @if (!showDetail) {
      <i class="fa fa-plus-square expandable-item__icon"></i>
    }
    @if (showDetail) {
      <i class="fa fa-minus-square expandable-item__icon"></i>
    }
  </div>
  <div class="expandable-detail">
    <ng-content select="[expandable-detail]"></ng-content>
  </div>
</div>